import Vue from 'vue'
import Element from 'element-ui'
import App from '@/App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/icons'
import '@/assets/scss/main.scss'
import '@/assets/theme/index.css'
import '@/assets/scss/aui.scss'
import http from '@/utils/request'
import http2 from '@/utils/http2'
import { hasPermission } from '@/utils'
import Cookies from 'js-cookie'
import vuescroll from 'vuescroll'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
import Empty from '@/components/Empty'
import moment from 'moment'
import '@/assets/scss/base.scss';
import Customer from '@/views/modules/trade/common/customer'
import Currency from '@/views/modules/trade/common/currency'
import factory from '@/views/modules/trade/common/factory'
import storages from '@/views/modules/trade/common/storages'
import company from '@/views/modules/trade/common/company'
import account from '@/views/modules/trade/common/account'
import DictDropdown from '@/components/DictDropdown'
import BigNumber from "bignumber.js";
import CommonUpload from '@/components/CommonUpload'
import MLabel from '@/components/MLabel'
import VueClipboard from 'vue-clipboard2'
import UserDrop from '@/components/UserDrop';
import Viewer from "v-viewer"
import 'viewerjs/dist/viewer.css'
import OrderDrop  from '@/components/order-drop'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import common from '@/utils/common'
import ToolTip from '@/components/tool-tip'
import qs from 'qs'
import api from '@/utils/api'
import api2 from '@/utils/api2'
import Consts from '@/utils/consts/index'
import ColorTip from '@/components/color-tip.vue'
import { checkVersion } from '@/utils/version'
/**自定义组件开始**/
import SweetTable from '@/components/SweetTable/index.vue'
import OrderStatusLabel from '@/components/OrderStatusLabel/index.vue'
/**自定义组件结束**/

Vue.use(VXETable)
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true, // 启用 inline 模式
    'button': true, // 显示右上角关闭按钮
    'navbar': true, // 显示缩略图导航
    'title': true, // 显示当前图片的标题
    'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    //'rotatable': true, // 图片是否可旋转
    //'scalable': true, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    //'fullscreen': true, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
    'url': 'src' // 设置大图片的 url
  }
})
Vue.use(VueClipboard)


Vue.component("SweetTable",SweetTable)
Vue.component("user-drop",UserDrop)
Vue.component("customer",Customer)
Vue.component("currency",Currency)
Vue.component("factory",factory)
Vue.component("storages",storages)
Vue.component("company",company)
Vue.component("account",account)
Vue.component("dict",DictDropdown)
Vue.component("common-upload",CommonUpload)
Vue.component("m-label",MLabel)
Vue.component("order-drop",OrderDrop)
Vue.component("tool-tip",ToolTip)
Vue.component("OrderStatusLabel",OrderStatusLabel)
Vue.component("color-tip",ColorTip)

// require('dayjs/locale/zh')

Vue.prototype.$api=api
Vue.prototype.$api2=api2
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts
Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
Vue.prototype.$copy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
Vue.prototype.$c=common
Vue.prototype.$const=Consts
Vue.prototype.$BigNumber=BigNumber
Vue.prototype.moneyFormat=(amount)=>{
  const m = new BigNumber(amount);
  return m.dividedBy(100).toFixed(2);
}
Vue.prototype.money=(amount)=>{
  const m = new BigNumber(amount);
  return m.toFixed(3);
}
Vue.prototype.$productName = (data) => {
  let pKeys=['code','productCode','skuCode','name','productName','nameZh','color','size','attr1','attr2','unit']
  let tmp=[]
  pKeys.forEach(k=>{
    if(!data[k]){
      return
    }
    tmp.push(data[k])
  })
  return tmp.join(' ')
}
Vue.component('m-empty', Empty)
Vue.use(VueTinymce) // 安装vue的tinymce组件
Vue.use(vuescroll, {
  ops: {
    // The global config
  },
})
Vue.config.productionTip = false

Vue.use(Element, {
  size: 'medium',
  i18n: (key, value) => i18n.t(key, value),
})
// Vue.component('vue-ueditor-wrap', VueUeditorWrap)

// 挂载全局
Vue.prototype.$export=(url,params,host,apiVersion)=>{
  
  if(!host){
    host=window.SITE_CONFIG['apiURL']
  }
  if(apiVersion==='v2'){
    host=window.SITE_CONFIG['api2URL']
  }
  if(!params){
    params={}
  }else{
    //移除params中为空的字段
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined || params[key] === '') {
        delete params[key]
      }
    })
  }
  params.token=Cookies.get('token')
  let exportParams = qs.stringify(params)
  window.location.href = `${host}${url}?${exportParams}`
}
Vue.prototype.$http = http
Vue.prototype.$http2 = http2
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$cookie = Cookies
// dayjs.locale("zh")
Vue.prototype.$moment = moment
Vue.prototype.$clone=(obj)=>{
 return JSON.parse(JSON.stringify(obj))
}

Vue.prototype.$dictFormat = (type, val) => {
  let dm = store.state.dictMap
  if (!dm) {
    return ''
  }
  let p = dm.find((item) => item.dictType === type)
  if (!p || !p.children) {
    return
  }
  let c = p.children.find((item) => item.dictValue === String(val))
  if (!c) {
    return ''
  }
  return c.dictName
}

// 保存整站vuex本地储存初始状态
// window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

window.vue = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// 启动时检查版本，之后每30分钟检查一次
checkVersion()
setInterval(checkVersion, 30 * 60 * 1000)
